import type { UserPreferencesPort, UserPreferencesUpdate } from '../domain/user-preferences'

const updateUserPreferences = (port: UserPreferencesPort, patch: UserPreferencesUpdate) => port.update(patch)

export { updateUserPreferences }
